import { ICustomer } from "./ICustomer";
import { BaseEntity, DefaultResponseWithData } from "./system";


export interface IPostcodeGroupsResponse extends DefaultResponseWithData<IPostcodeGroup[]> { }
export interface IPostcodeGroupResponse extends DefaultResponseWithData<IPostcodeGroup> { }

export interface IPostcodeGroup extends BaseEntity {
  name: string;
  postcode: string;
  basePrice: number;

  onlyGoodEngineCondition: boolean;
  onlyGoodBodyCondition: boolean;

  isActive: boolean;

  thresholdPrice: number;

  customerId: string;
  customer: ICustomer;

  postcodePrices: IPostcodePrice[];

  yearRules: IPostcodeYearRule[];
}


export interface IPostcodePrice extends BaseEntity {
  postcode: string;
  price: number;

  onlyGoodEngineCondition: boolean;
  onlyGoodBodyCondition: boolean;

  isActive: boolean;

  thresholdPrice: number;

  postcodeGroupId: string;
  postcodeGroup: IPostcodeGroup;

  yearRules: IPostcodeYearRule[];
}


export interface CreatePostcodePriceRequest {
  postcode: string;
  price: number;
  postcodeGroupId: string;

  onlyGoodEngineCondition: boolean;
  onlyGoodBodyCondition: boolean;

  thresholdPrice: number;
}


/**
 * Moves the price per tonne of one group, or one area, for a band of vehicle years. Bounds are
 * inclusive, matching the From/To year fields on the specific rules — "newer than 2015" is written
 * as From 2016.
 *
 * Exactly one of postcodeGroupId and postcodePriceId is set.
 */
export interface IPostcodeYearRule extends BaseEntity {
  fromYear: number | null;
  toYear: number | null;
  pricePerTonne: number;
  isActive: boolean;

  postcodeGroupId: string | null;
  postcodePriceId: string | null;
}

export interface CreatePostcodeYearRuleRequest {
  postcodeGroupId?: string | null;
  postcodePriceId?: string | null;
  fromYear: number | null;
  toYear: number | null;
  pricePerTonne: number;
  isActive: boolean;
}

export interface UpdatePostcodeYearRuleRequest {
  id: string;
  fromYear: number | null;
  toYear: number | null;
  pricePerTonne: number;
  isActive: boolean;
}


// ---------- Test modal ---------- //

export enum PostcodePriceSource {
  None = 0,
  Group = 1,
  Area = 2,
}

export interface IPostcodePriceTestRequest {
  vrm: string;
  postcode: string;
  engineCondition: number;
  bodyCondition: number;
}

export interface IPostcodePriceTestOwner {
  id: string;
  name: string | null;
  postcode: string;
  pricePerTonne: number;
  thresholdPrice: number;
  isActive: boolean;
  onlyGoodEngineCondition: boolean;
  onlyGoodBodyCondition: boolean;
}

export interface IPostcodeYearRuleTestResult {
  id: string;
  isGroupRule: boolean;
  owner: string;
  fromYear: number | null;
  toYear: number | null;
  years: string;
  pricePerTonne: number;
  isActive: boolean;
  matched: boolean;
  applied: boolean;
  reasons: string[];
}

export interface IPostcodePriceTestResponse {
  vrm: string;
  postcode: string;
  vehicleFound: boolean;
  message: string | null;

  year: number;
  make: string | null;
  model: string | null;

  outcode: string;
  areaCode: string;

  group: IPostcodePriceTestOwner | null;
  area: IPostcodePriceTestOwner | null;

  source: PostcodePriceSource;
  blockers: string[];

  basePricePerTonne: number;
  effectivePricePerTonne: number;
  thresholdPrice: number;

  appliedYearRuleId: string | null;
  yearRules: IPostcodeYearRuleTestResult[];
}